import React, { useState } from 'react'
import UserTable from './Components/UsersTable/UserTable'
import UserAndRollTable from './Components/UserRollTable/UserAndRollTable'

const Privileges = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div>
            {/* x---------------------------------x Users & User Roll Table Section x---------------------------------x */}
            <div className="bg-body text-dark mx-0 px-0">
                <div className="grid lg:grid-cols-2 grid-cols-1 gap-4 ">
                    <div className="border rounded-md pb-2">
                        <div className="p-4">
                            <h3 className="text-lg font-semibold">User &amp; Roles</h3>
                        </div>
                        {/* x---------------------------------x Users Roll Table Section x---------------------------------x */}
                        <div>
                            <UserAndRollTable editModal={setIsOpen} />
                        </div>
                    </div>
                    <div className="border rounded-md pb-2">
                        <div className="p-4">
                            <h3 className="text-lg font-semibold">Users</h3>
                        </div>
                        {/* x---------------------------------x User Table section x---------------------------------x */}
                        <div>
                            <UserTable />
                        </div>
                    </div>
                </div>
            </div>

            {/* x---------------------------------x Roll Edit Modal x---------------------------------x */}
            <div className="relative z-50">
                {isOpen && (
                    <div
                        className="fixed px-2 top-0 inset-0 bg-gray-900 bg-opacity-50 flex items-start justify-center transition-opacity duration-300 ease-in-out pt-10 overflow-y-scroll pb-10  "
                        onClick={() => setIsOpen(false)}>
                        <div
                            className={`bg-light1 text-dark py-4 rounded-lg shadow-lg relative w-full max-w-xs sm:max-w-md md:max-w-lg 
                            transform transition-all duration-300 ease-in-out 
                            ${isOpen ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}
                            onClick={(e) => e.stopPropagation()}>
                            <div className='modal_header mb-5 border-b border-gray-600 pb-4 flex justify-between items-center' >
                                <div className="w-full p-4 text-dark">
                                    <h2 className="text-xl font-semibold">New Change</h2>
                                </div>
                                <button
                                    onClick={() => setIsOpen(false)}
                                    className="px-4 py-2 mr-6 rounded">
                                    <svg
                                        xmlns="http://www.w3.org/6000/svg"
                                        className="h-6 w-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    </svg>
                                </button>
                            </div>
                            <div className="modal_body text-dark px-6">
                                <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-2">
                                    {/* x---------------------------------x First Name x---------------------------------x */}
                                    <div className="col-span-1 md:col-span-2 lg:col-span-1">
                                        <label className="text-sm">First Name</label>
                                        <input
                                            type="text"
                                            className="bg-light border-[0.5px] hover:border-primary border-gray-600 rounded-lg py-4 px-3 w-full focus:outline-none focus:ring-0 focus:border-dashed"
                                            placeholder="Add First Name"
                                        />
                                    </div>

                                    {/* x---------------------------------x Last Name x---------------------------------x */}
                                    <div className="col-span-1 md:col-span-2 lg:col-span-1">
                                        <label className="text-sm">Last Name</label>
                                        <input
                                            type="text"
                                            className="bg-light border-[0.5px] hover:border-primary border-gray-600 rounded-lg py-4 px-3 w-full focus:outline-none focus:ring-0 focus:border-dashed"
                                            placeholder="Add Last Name"
                                        />
                                    </div>

                                    {/* x---------------------------------x Email x---------------------------------x */}
                                    <div className="col-span-1 md:col-span-2">
                                        <label className="text-sm">Email</label>
                                        <input
                                            type="email"
                                            className="bg-light border-[0.5px] hover:border-primary border-gray-600 rounded-lg py-4 px-3 w-full focus:outline-none focus:ring-0 focus:border-dashed"
                                            placeholder="Add Email"
                                        />
                                    </div>

                                    {/* x---------------------------------x Password x---------------------------------x */}
                                    <div className="col-span-1 md:col-span-2">
                                        <label className="text-sm">Password</label>
                                        <input
                                            type="password"
                                            className="bg-light border-[0.5px] hover:border-primary border-gray-600 rounded-lg py-4 px-3 w-full focus:outline-none focus:ring-0 focus:border-dashed"
                                            placeholder="Add Password"
                                        />
                                    </div>

                                    {/* x---------------------------------x About x---------------------------------x */}
                                    <div className="col-span-1 md:col-span-2 lg:col-span-3">
                                        <label className="text-sm">About</label>
                                        <textarea
                                            className="bg-light border-[0.5px] hover:border-primary border-gray-600 rounded-lg py-4 px-3 w-full focus:outline-none focus:ring-0 focus:border-dashed"
                                            rows="5"
                                            placeholder="Tell us about yourself"
                                        ></textarea>
                                    </div>

                                    {/* x---------------------------------x File Upload x---------------------------------x */}
                                    <div className="col-span-1 md:col-span-2 lg:col-span-1">
                                        <input type="file" className="w-full rounded-lg py-2 focus:outline-none" />
                                    </div>

                                    {/* x---------------------------------x Radio Buttons x---------------------------------x */}
                                    <div className="col-span-1 md:col-span-2 lg:col-span-1 flex space-x-4">
                                        <label className="flex items-center space-x-2">
                                            <input
                                                type="radio"
                                                className="form-radio text-primary focus:ring-primary"
                                                name="status"
                                                defaultChecked
                                            />
                                            <span>Active</span>
                                        </label>
                                        <label className="flex items-center space-x-2">
                                            <input
                                                type="radio"
                                                className="form-radio text-primary focus:ring-primary"
                                                name="status"
                                            />
                                            <span>Inactive</span>
                                        </label>
                                    </div>
                                </div>

                            </div>
                            <div className="modal_footer border-t flex justify-end pt-3 pr-3">
                                <button className='py-2 px-5 rounded-lg bg-gray-600 hover:bg-gray-700 text-white mr-3 ' onClick={() => setIsOpen(false)}>
                                    Close
                                </button>
                                <button className='py-2 px-5 rounded-lg bg-primary-800 hover:bg-primary-900 text-white' >
                                    Save
                                </button>
                            </div>
                        </div >
                    </div >
                )}
            </div >
        </div >

    )
}

export default Privileges